import { useCallback } from 'react';
import { isLogicGroup } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { useGetOperators } from './useGetOperators';
import { useStrategy } from './useStrategy';
import { useTranslationHelpers } from './useTranslationHelpers';
import { isPropertyChangedEventTypeId, isPropertyNameAndValueCondition } from '../strategy/propertyChangedFilterUtils';
import { isOperator } from '../filterQueryFormat/operator/Operator';
import { FilterLogicGroupError } from '../filterQueryFormat/FilterLogicGroupError';
const _validateLogicGroup = (logicGroup, validateCondition) => {
  let validatedLogicGroup = logicGroup.set('errors', []);
  if (isPropertyChangedEventTypeId(logicGroup.filterFamily)) {
    if (!logicGroup.conditions.some(isPropertyNameAndValueCondition)) {
      validatedLogicGroup = validatedLogicGroup.set('errors', [new FilterLogicGroupError('Property name and value filter is missing')]);
    }
  }
  const validatedConditions = logicGroup.conditions.map(condition => {
    if (isLogicGroup(condition)) {
      return _validateLogicGroup(condition, validateCondition);
    }
    if (isOperator(condition) && typeof validateCondition === 'function') {
      return validateCondition(logicGroup.filterFamily, condition, {
        shouldValidateRefinement: true
      });
    }
    return condition;
  });
  return validatedLogicGroup.set('conditions', validatedConditions);
};
export const useValidateCondition = () => {
  const {
    getOperators,
    getRefinementOperators
  } = useGetOperators();
  const {
    validateCondition: validateConditionSrc,
    getValueResolver
  } = useStrategy();
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
  const {
    getOperatorLabelString
  } = useTranslationHelpers();
  const validateCondition = useCallback((filterFamily, condition, options = {}) => {
    const validOperators = condition.field.refinement ? getRefinementOperators(filterFamily, condition.field) : getOperators(filterFamily, condition.field, condition);
    const fieldResolver = getValueResolver(filterFamily, condition);
    const operatorLabel = getOperatorLabelString(condition.constructor, condition.field);
    return validateConditionSrc(condition, Object.assign({
      fieldResolver,
      validOperators,
      operatorLabel,
      filterFamily
    }, options));
  }, [getValueResolver, getOperators, getRefinementOperators, getOperatorLabelString, validateConditionSrc]);
  const validateLogicGroup = useCallback((logicGroup, shouldValidateConditions = true) => {
    if (shouldValidateConditions) {
      return _validateLogicGroup(logicGroup, validateCondition);
    }
    return _validateLogicGroup(logicGroup);
  }, [validateCondition]);
  return {
    validateCondition,
    validateLogicGroup
  };
};